module.exports = __webpack_public_path__ + "static/media/Baslik.d2541212.png";